import _intersection from 'lodash.intersection';

export function intersection(arr1: any[], arr2: any[]) {
  return _intersection(arr1, arr2);
}
